import MapSidebar from "./MapSidebar";
import BottomSheet from "../BottomSheet";

class MapEventSidebar extends MapSidebar{

    constructor(){
        super();

        let self = this;

        this.class = 'mapSidebar';
        this.mapSidebar = $('<div class="'+this.class+' sheet_contents mapSidebar_eventView custom-scrollbar"></div>');
        this.closeSidebar = $('<div class="closeSidebar crossSidebar"><i class="icon-chevron-right"></i></div>');
        this.container = $('<div class="mapSidebarWraper sheet"></div>');
        this.container.html(this.mapSidebar);
    }

    getContainer(){
        return this.container;
    }

    getClass(){
        return this.class;
    }

    renderSidebar(html, route_points) {

        let self = this;

        let htmlContent = $(html);

        if(route_points){
            htmlContent.find('.m_event-routePoints-content').html(renderRouteSteps(route_points))
        }

        self.mapSidebar.html(htmlContent);
        self.mapSidebar.append(self.closeSidebar);

        self.mapSidebar.find('.crossSidebar').on('click', function(){
            self.hideSidebar();
        })

    }

    showSidebar() {
        let self = this;
        this.mapSidebar.addClass('active');

        if(window.innerWidth <= 800){
            (new BottomSheet(this.container[0]).shown());
            this.container.on('onClose', function(){
                self.hideSidebar();
            })
            $('#map').css('height', '60%');
        }

    }

    hideSidebar() {
        let self = this;
        this.mapSidebar.removeClass('active');
        this.getContainer().trigger('onClosed');
        setTimeout(function(){
            self.container.remove();
        }, 300);
        $('#map').css('height', '100%');

    }
}

export default MapEventSidebar